import React from "react";
import OrixiaRow from "./OrixiaRow";

const MemoizedOrixiaRow = React.memo(OrixiaRow)

export default MemoizedOrixiaRow